/**
 *
 * @version 12.4.0 #756 MLIBJS-121 Export wd-directives as a node module
 * 
 * @author Erik Orozco <eorozco@intersog.com>
 * 
 * @copyright (c) 2020 Build Centrix
 *
 */

var wdConfirm = require('./confirmation/wdConfirm');
var wdContentEditable = require('./wdContentEditable');
var wdDropUpOrDown = require('./wdDropUpDirective');
var wdFilters = require('./wdFilters');
var wdFocusMe = require('./wdFocusMe');
var wdLoading = require('./wdLoading');
var wdSelectOnFocus = require('./wdSelectOnFocus');

module.exports = {
    wdContentEditable: wdContentEditable.name,
    wdConfirm: wdConfirm.name,
    wdDropUpOrDown: wdDropUpOrDown.name,
    wdFilters: wdFilters.name,
    wdFocusMe: wdFocusMe.name,
    wdLoading: wdLoading.name,
    wdSelectOnFocus: wdSelectOnFocus.name
};

// EOF